import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from '@anxious-unicorn/app-routing.module';
import { AppComponent } from '@anxious-unicorn/app.component';
import { CoreModule } from '@anxious-unicorn/core/core.module';
import { SharedModule } from '@anxious-unicorn/shared/shared.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    SharedModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
